// Shared constants for module 0.1 (User Pages)

// =============================================================================
// Boolean-like string parsing sets (for normalizing backend responses)
// =============================================================================
export const TRUTHY_STRINGS = ['true', '1', 'yes', 'y', 'sim', 's'] as const;
export const FALSY_STRINGS = ['false', '0', 'no', 'n', 'nao', 'não'] as const;
export const ACTIVE_STATUS_STRINGS = ['ACTIVE', 'ATIVO', 'ACTIVE', 'ATIVADA'] as const;
export const INACTIVE_STATUS_STRINGS = ['INACTIVE', 'INATIVO', 'INACTIVE', 'DESATIVADA', 'DESATIVADO'] as const;
